import React, { useEffect, useState } from "react"
import { Box, Divider, TextField, Typography } from "@mui/material"
import { useCompany } from "src/providers"
import { getCompanyEmailDomains } from "src/services/api/company"
import { SectionHeader } from "./companyInfoComponents"

export const CompanyDomainsPanel = () => {
  const { companyId } = useCompany()
  const [domains, setDomains] = useState<string[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    getCompanyEmailDomains(companyId)
      .then(setDomains)
      .catch(() => setDomains([]))
      .finally(() => setLoading(false))
  }, [companyId])

  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="text.secondary">Loading...</Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ mb: 4 }}>
      <SectionHeader title="Company Domains" />
      <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 1 }}>
        {domains.length === 0 ? (
          <TextField
            size="small"
            value="-"
            disabled
            sx={{
              "& .Mui-disabled": { backgroundColor: "#FAFAFA" },
              "& .MuiInputBase-input": { color: "#898989" }
            }}
          />
        ) : (
          domains.map((domain) => (
            <TextField
              key={domain}
              size="small"
              value={domain}
              disabled
              sx={{
                "& .Mui-disabled": { backgroundColor: "#FAFAFA" },
                "& .MuiInputBase-input": { color: "#898989" }
              }}
            />
          ))
        )}
      </Box>
    </Box>
  )
}
